<template>
    <div>
        <div class="hrline-text">
            <span>Link</span>
        </div>

        <app-code>
            {{link}}
        </app-code>
    </div>
</template>

<script setup lang="ts">
    import {usePortuna} from '@/composables/portuna';
    import AppCode from './AppCode.vue';

    const portuna = usePortuna();

    defineProps<{
        link: string;
    }>();

    defineExpose(Object.assign({}, portuna, {
        componentName: 'CopyLinkPopup',
    }));
</script>